import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Component({
  selector: 'app-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[id]': 'id',
  }
})
export class LabelComponent extends FieldType<FieldTypeConfig> {

  constructor(private domSanitizer: DomSanitizer) {
    super();
  }

  getContent(): SafeHtml {
    return this.domSanitizer.bypassSecurityTrustHtml(this.props['label'] || "");
  }
}
